import "./styles.scss"

interface IPropsTag {
  children: any,
  tooltip?: string,
  inline?: boolean,
  size?: "sm" | "md" | "lg"
}

const Tag = ({ children, tooltip, size, inline }: IPropsTag) => {
  return (
    <div className={`tag ${tooltip && "hasTooltip"} ${inline && "inline"} ${size}`}>
      {tooltip && <div className="tag__tooltip">{tooltip}</div>}
      <p className="paragraph paragraph--sm">{children}</p>
    </div>
  );
};

export default Tag;
